export const Types = {
    SAVE_LIST_FEATURE_TECH: 'SAVE_LIST_FEATURE_TECH',
}
